import { CommonModule } from '@angular/common';
import {
    CUSTOM_ELEMENTS_SCHEMA,
    NgModule,
    NO_ERRORS_SCHEMA,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { TreeviewModule } from '@samotics/ngx-treeview';
import { DataTablesModule } from 'angular-datatables';
import { BlockCopyPasteDirective } from '../services/common/block-paste.directive';
import { HasPermissionForTargetDirective } from '../services/common/has-permission-for-target.directive';
import { HasPermissionDirective } from '../services/common/has-permission.directive';
import { ConfirmDialogModule } from './confirm-dialog/confirm-dialog.module';
import { DatatableComponent } from './datatable/datatable.component';
import { EnrollmentContainerComponent } from './enrollment/enrollment-container/enrollment-container.component';
import { EnrollmentModule } from './enrollment/enrollment.module';
import { KeysPipe } from './pipes/filter.pipe';
import { RowDetailComponent } from './row-detail/row-detail.component';
import { StyledMessageComponent } from './styled-message/styled-message.component';
import { SuperAdminTenantWarningComponent } from './super-admin-tenant-warning/super-admin-tenant-warning.component';

@NgModule({
  declarations: [
    StyledMessageComponent,
    DatatableComponent,
    EnrollmentContainerComponent,
    RowDetailComponent,
    SuperAdminTenantWarningComponent,
  ],
  imports: [
    KeysPipe,
    HasPermissionDirective,
    HasPermissionForTargetDirective,
    BlockCopyPasteDirective,
    TreeviewModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    CommonModule,
    NgSelectModule,
    NgbModule,
    ConfirmDialogModule,
    DataTablesModule,
    EnrollmentModule,
  ],
  exports: [
    TreeviewModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    CommonModule,
    NgSelectModule,
    NgbModule,
    HasPermissionDirective,
    HasPermissionForTargetDirective,
    BlockCopyPasteDirective,
    ConfirmDialogModule,
    EnrollmentModule,
    DatatableComponent,
    EnrollmentContainerComponent,
    RowDetailComponent,
    KeysPipe,
    SuperAdminTenantWarningComponent   
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class SharedModule {
}
